export const ActionTypes = {
    SET_ITEMS: "SET_ITEMS",
    SELECTED_ITEM: "SELECTED_ITEM",
    REMOVE_SELECTED_ITEM: "REMOVE_SELECTED_ITEM",
}